<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">平台广告发布协议</div>
    <p class="main_synopsis" style="font-weight: 600">
      本协议由用户和神州邦邦平台（北京神州邦邦技术服务有限公司）签订，就用户在神州邦邦平台（
      <a href="www.shenzhoubb.com">www.shenzhoubb.com</a>
      ）上发布广告事宜，现根据《中华人民共和国民法典》、《中华人民共和国广告法》等有关法律、法规、规章的规定，制定以下条款，用以明确用户和神州邦邦平台双方各自的权利义务，并遵照执行。
    </p>
    <div class="main_item">
      <p>
        第一条　用户委托神州邦邦平台发布广告，该广告用于用户的宣传，神州邦邦平台在（<a
          href="www.shenzhoubb.com"
          >www.shenzhoubb.com</a
        >）上发布该广告。
      </p>
    </div>
    <div class="main_item">
      <p>
        第二条
        本协议所指的付款包括在线点击充值和线下转账等方式。广告的形式、规格、位置、费用和发布时间等由用户在神州邦邦平台系统中自行选择；内容由用户自行负责，神州邦邦平台有审核权利，对于不合规广告神州邦邦平台有权拒绝。
      </p>
    </div>
    <div class="main_item">
      <p>第三条　双方的权利义务</p>
      <ul class="content_wrap1">
        <li>
          <p>
            用户有权对广告的发布进行监督，并有权向神州邦邦平台提出维护更新意见。
          </p>
        </li>
        <li>
          <p>
            用户不得在其制作的广告中包含有关色情、宗教、人种歧视、政治敏感问题、侵犯他人合法权益等内容，否则神州邦邦平台有权终止协议并不退还已收费用。
          </p>
        </li>
        <li>
          <p>
            用户在其广告正常传播（显示）期间，由于违规导致其所经营的企业认证账号被封或者所从事的服务被关闭，神州邦邦平台有权要求用户调整广告内容（调整为该用户其他企业认证账号或服务广告），否则神州邦邦平台有权终止协议且不退还已收费用。
          </p>
        </li>
        <li>
          <p>
            用户在其广告正常传播（显示）期间，单方面要求终止协议，神州邦邦平台有权不退还已收费用。
          </p>
        </li>
        <li>
          <p>
            用户应严格按照协议约定履行付款义务，一经付款，除本协议另行约定外，该款项不予退还，直至用户使用完毕；用户逾期付款，神州邦邦平台有权终止履行自身义务。
          </p>
        </li>
        <li>
          <p>
            广告制作完成后，非经神州邦邦平台同意不得更换；神州邦邦平台负责正式发布播放，并保证被播放广告的正常显示和访问。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台应严格按照协议约定履行广告发布义务，如不能按约履行义务应当及时向用户说明原因并退还相关款项。
          </p>
        </li>
        <li>
          <p>
            如在广告发布过程中由于神州邦邦平台系统原因或者版面调整等因素导致用户广告未能按约发布（未能正常显现），神州邦邦平台将对用户广告给予延时补偿，补偿以小时为基数，不足1小时按照1小时计算。
          </p>
        </li>
        <li>
          <p>
            本协议生效后，未经神州邦邦平台事前书面同意，用户不得转让本协议约定的任何权利。
          </p>
        </li>
        <li>
          <p>
            因不可抗力，或者国家法律、法规、政策的变化，造成广告不能正常发布的，双方均不承担违约责任；广告费按照实际发布时间计算，或由双方另行签订补充协议议定相关事项。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第四条 法律适用及争议解决</p>
      <ul class="content_wrap1">
        <li>
          <p>
            本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
          </p>
        </li>
        <li>
          <p>
            因本协议就协议内容或其执行发生任何争议，双方友好协商解决；如果协商不成，任何一方均可向北京仲裁委员提起仲裁，其裁决是终局性的，对双方具有约束力。
          </p>
        </li>
        <li>
          <p>
            本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>
        第五条　本协议经用户点击同意且广告费用支付至神州邦邦平台指定账户后即行生效。
      </p>
    </div>
    <div class="main_item">
      <p>
        第六条　本协议没有约定的，适用《神州邦邦平台服务协议》和《神州邦邦平台服务规则》的相关规定。
      </p>
    </div>
    <div class="main_item">
      <p>第七条 本协议自双方履行完各自的义务后终止。</p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>